const intentoryLogReportSelectSeriesType = {
  SeriesActivityDates: 0,
  Plates: 1,
  NotFullyIssuedSeries: 2,
};

export default intentoryLogReportSelectSeriesType;
